import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchFilterBar = ({ 
  searchQuery, 
  onSearchChange, 
  selectedCategory, 
  onCategoryChange, 
  sortBy, 
  onSortChange,
  dateRange,
  onDateRangeChange,
  onClearFilters,
  totalResults
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'legal', label: 'Legal' },
    { value: 'technical', label: 'Technical' },
    { value: 'creative', label: 'Creative' },
    { value: 'business', label: 'Business' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'category', label: 'By Category' },
    { value: 'alphabetical', label: 'A-Z' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'Last 3 Months' }
  ];

  const hasActiveFilters = selectedCategory !== 'all' || dateRange !== 'all' || searchQuery?.length > 0;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Desktop Layout */}
      <div className="hidden md:block">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4 flex-1">
            {/* Search Input */}
            <div className="flex-1 max-w-md">
              <Input
                type="search"
                placeholder="Search prompts..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e?.target?.value)}
                className="w-full"
              />
            </div>

            {/* Category Filter */}
            <div className="w-48">
              <Select
                options={categoryOptions}
                value={selectedCategory}
                onChange={onCategoryChange}
                placeholder="Category"
              />
            </div>

            {/* Date Range Filter */}
            <div className="w-40">
              <Select
                options={dateRangeOptions}
                value={dateRange}
                onChange={onDateRangeChange}
                placeholder="Date"
              />
            </div>

            {/* Sort By */}
            <div className="w-40">
              <Select
                options={sortOptions}
                value={sortBy}
                onChange={onSortChange}
                placeholder="Sort"
              />
            </div>
          </div>

          {/* Clear Filters */}
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconSize={14}
            >
              Clear
            </Button>
          )}
        </div>

        {/* Results Count */}
        <div className="flex items-center justify-between text-sm text-text-secondary">
          <span>{totalResults} prompts found</span>
          {hasActiveFilters && (
            <span className="flex items-center space-x-1">
              <Icon name="Filter" size={14} />
              <span>Filters active</span>
            </span>
          )}
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Search prompts..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
            />
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowMobileFilters(!showMobileFilters)}
            iconName="Filter"
            iconSize={16}
          >
            Filters
          </Button>
        </div>

        {/* Mobile Filter Panel */}
        {showMobileFilters && (
          <div className="space-y-4 pt-4 border-t border-border">
            <Select
              label="Category"
              options={categoryOptions}
              value={selectedCategory}
              onChange={onCategoryChange}
            />
            <Select
              label="Date Range"
              options={dateRangeOptions}
              value={dateRange}
              onChange={onDateRangeChange}
            />
            <Select
              label="Sort By"
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
            />
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearFilters}
                iconName="X"
                iconSize={14}
                fullWidth
              >
                Clear All Filters
              </Button>
            )}
          </div>
        )}

        {/* Mobile Results Count */}
        <div className="flex items-center justify-between text-sm text-text-secondary mt-4">
          <span>{totalResults} prompts</span>
          {hasActiveFilters && (
            <span className="flex items-center space-x-1">
              <Icon name="Filter" size={14} />
              <span>Active</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;